/**
 * Comprueba si un número de cuenta dado es correcto
 * Para ello, debe estar compuesto únicamente por números
 * NO se limita, en estos momentos, el número de dígitos
 * @param {*} value Número de cuenta a validar
 * @returns true si es un número de cuenta válido
 */
export const validateAccount = (value) => /^\d+\.?\d*\??$/.test(value) 

